(function ($) {
    $(document).ready(function () {
      $(".searchable-select").selectpicker();
    });
  })(jQuery);